'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
exports.getProbableInterfaces = void 0;
var interfaces_1 = require('./interfaces');
function getProbableInterfaces(methodNames) {
  var probableInterfaces = Object.keys(interfaces_1.interfaces).filter(
    function (i) {
      return interfaces_1.interfaces[i].methods.every(function (m) {
        return methodNames.indexOf(m.name) !== -1;
      });
    },
  );
  var byMethod = {};
  methodNames.forEach(function (methodName) {
    byMethod[methodName] = probableInterfaces.filter(function (i) {
      return (
        interfaces_1.interfaces[i].methods
          .map(function (m) {
            return m.name;
          })
          .indexOf(methodName) !== -1
      );
    });
  });
  return { probableInterfaces: probableInterfaces, byMethod: byMethod };
}
exports.getProbableInterfaces = getProbableInterfaces;
//# sourceMappingURL=getProbableInterfaces.js.map
